import { DEFAULT_CHART_WIDTH } from '../constants';
import { processDateSeriesCsvData, scaled } from '../utils';
import * as d3 from 'd3';
import lineChart from '../utils/line-chart';

export default function() {
  // required parameters
  let data;

  // optional parameters
  let chartId = 'ireland-cases-deaths';

  const height = scaled(400, width);
  const padding = [20, 20, 40, 40];
  const events = [
    {name: '1st lockdown', startDate: '2020-03-12', endDate: '2020-05-18'},
    {name: '2nd lockdown', nameAnchor: 'end', startDate: '2020-10-22', endDate: '2020-11-30'},
    {name: '3rd lockdown', nameAnchor: 'end', startDate: '2020-12-31', endDate: 'current'}
  ];

  const chart = function(selection) {
    selection.each(function() {
      let timer, tooltip;

      const container = d3.select(this);
      container.attr('id', chartId)
        .attr('class', 'chart');

      const [lines, dates] = processDateSeriesCsvData(data, ['type']);

      container.append('svg')
        .datum({lines, dates})
        .attr('id', 'ireland-cases-deaths')
        .attr('class', 'chart')
        .attr('viewBox', `0 0 ${width} ${height}`)
        .attr('preserveAspectRatio', 'xMinYMin meet')
        .call(lineChart()
          .width(width)
          .height(height)
          .padding(padding)
          .classNameAccessor(function(d) {
            switch(d.type) {
              case 'new_cases': return 'cases';
              case 'new_deaths': return 'deaths'
            }
          })
          .strokeAccessor(function(d) {
            switch(d.type) {
              case 'new_cases': return '#3073bf';
              case 'new_deaths': return '#b81228'
            }
          })
          .mouseOverAccessor(function(event, d) {
            if (timer) {
              window.clearTimeout(timer);
            }
            const position = d3.pointer(event, container.node())
            tooltip.attr('style', `display:block; left: ${position[0] + 10}px; top: ${position[1]}px`)
            let label;
            switch(d.type) {
              case 'new_cases':
                label = 'Cases';
                break;
              case 'new_deaths':
                label = 'Deaths';
                break
            }
            tooltip.node().innerHTML = label
          })
          .mouseOutAccessor(function() {
            timer = window.setTimeout(function() {
              tooltip.attr('style', 'display:none')
            }, 300)
          })
          .frontLineAccessor(d => d.type === 'new_cases')
          .events(events));

      tooltip = container.append('div')
        .attr('class', 'tooltip')
    });
  };

  chart.data = function(_) {
    if (!arguments.length) return data;
    data = _;
    return chart;
  };

  chart.chartId = function(_) {
    if (!arguments.length) return chartId;
    chartId = _;
    return chart;
  };

  return chart;
}
